import React, { useMemo } from 'react';

import { CategoryProvider, useCategoryState, useSportsbookState, useSportState } from '@atlas/core';

import { useSimplifiedSportsbook } from 'common/SimplifiedSportsbook/SimplifiedSportsbookContext';
import { useSearch } from 'hooks/useSearch';
import { navigationTypes } from 'iframe/constants';

import SimplifiedViewLoader from './SimplifiedViewLoader';

const SimplifiedTopTournamentsViewProvider = ({ children, firstItemChild = null }) => {
  const { id } = useSportsbookState();
  const { categories } = useSportState();
  const { isLiveTopTournaments } = useSimplifiedSportsbook();
  const { initialized, loading, tournaments } = useCategoryState();
  const { isOpenedSimpleSearch } = useSearch();

  return useMemo(() => {
    if (
      id === navigationTypes.sportLive &&
      initialized &&
      !loading &&
      !isLiveTopTournaments &&
      !isOpenedSimpleSearch
    ) {
      return (
        <>
          {categories.map((category, index) => (
            <CategoryProvider category={category} key={category.id}>
              <SimplifiedViewLoader>
                {!index && firstItemChild}
                {children}
              </SimplifiedViewLoader>
            </CategoryProvider>
          ))}
        </>
      );
    }

    return (
      <>
        {firstItemChild}
        {children}
      </>
    );
  }, [firstItemChild, tournaments, isLiveTopTournaments, isOpenedSimpleSearch]);
};

export default SimplifiedTopTournamentsViewProvider;
